/**
 * Every comment, update, file and estimate carries a visibility.
 * INTERNAL rows are never serialized into client-portal responses.
 */
export const VISIBILITY = {
    INTERNAL: 'INTERNAL',
    CLIENT: 'CLIENT',
};
export const VISIBILITY_LABELS = {
    INTERNAL: 'Internal',
    CLIENT: 'Client-visible',
};
//# sourceMappingURL=visibility.js.map